window.addEventListener('load', function () {
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((item, index) => {
    const label = item.querySelector(".ac-label");
    const content = item.querySelector(".ac-content");

    // Open first item by default
    if (index === 0) {
      content.style.maxHeight = content.scrollHeight + "px";
    }

    label.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      // Close all items before opening the clicked one
      accordionItems.forEach((el) => {
        el.classList.remove("active");
        el.querySelector(".ac-content").style.maxHeight = null;
      });

      // Toggle the clicked item
      if (!isOpen) {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});